var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83398 15.484V8.58961C3.83398 5.56181 3.83398 4.04791 4.81029 3.10729C5.78661 2.16667 7.35795 2.16667 10.5007 2.16667C13.6433 2.16667 15.2147 2.16667 16.191 3.10729C17.1673 4.04791 17.1673 5.56181 17.1673 8.58961V15.484C17.1673 17.4056 17.1673 18.3663 16.5233 18.7103C15.2761 19.3762 12.9367 17.1543 11.8257 16.4853C11.1813 16.0973 10.8592 15.9033 10.5007 15.9033C10.1422 15.9033 9.81998 16.0973 9.17565 16.4853C8.06465 17.1543 5.72521 19.3762 4.47803 18.7103C3.83398 18.3663 3.83398 17.4056 3.83398 15.484Z",
    fill: "#0464B2",
    stroke: "#0464B2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveBookmark);
export default __webpack_public_path__ + "static/media/saveBookmark.43c98dfe188bc37dccab39b28f412003.svg";
export { ForwardRef as ReactComponent };